<template>
    <div class="d-flex align-center">
        <v-menu offset-y @input="isOpen = $event" :value="isOpen">
            <template v-slot:activator="{on}">
                <v-text-field v-model="term" @input="search()" @click="forceOpen()" style="min-width: 400px" class="search-input no-validation" append-icon="mdi-magnify" label="Wyszukaj produkt" dense outlined ></v-text-field>
            </template>
            <v-list>
                <v-list-item v-if="loading">
                    <div class="w-100 d-flex justify-center">
                        <v-progress-circular indeterminate color="primary"></v-progress-circular>
                    </div>
                </v-list-item>
                <v-list-item v-for="item in data" :href="item.url">
                    <v-list-item-avatar tile>
                        <v-img :src="$root.getSrc(item.photo)"></v-img>
                    </v-list-item-avatar>
                    <v-list-item-content>
                        <v-list-item-title>{{item.name}}</v-list-item-title>
                        <div class="grey--text mt-1" style="font-size: 0.9rem">{{item.description}}</div>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-menu>
    </div>
</template>
<script>
    import {search} from "../../api/app";

    export default {
        data:() => {
            return{
                data:[],
                isOpen: false,
                term: '',
                loading: true,
            }
        },
        methods:{
            forceOpen(){
                this.isOpen = false;
                setTimeout(() => {
                    this.isOpen = true;
                }, 20)
            },
            search(){
                if(this.term.length > 0){
                    this.loading = true;
                    search({term: this.term}).then(response => {
                        this.data = response;
                        this.loading = false;
                    }).catch(e => {
                        this.loading = false;
                        this.$store.commit('app/ADD_MESSAGE', {text: 'Nie udało się pobrać elementów', type: 'error'});
                    })
                }else{
                    this.loading = true;
                    this.data = [];
                }
            }
        }
    }
</script>
<style lang="scss">
    .search-input{

    }
</style>
